import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn `cn()` helper — merges class names with clsx (conditional + falsy-strip)
 * then resolves Tailwind utility conflicts via tailwind-merge.
 *
 * Phase 66 Plan 01: required by every shadcn primitive in src/components/ui/*.tsx.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
